import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from '../../base.component';

@Component({
	selector: 'app-kickout-mfh-expert-box',
	templateUrl: './kickout-mfh-expert-box.component.html',
	styleUrls: ['./kickout-mfh-expert-box.component.scss'],
})
export class KickoutMfhExpertBoxComponent extends BaseComponent implements OnInit {
	constructor(injector: Injector) {
		super(injector);
	}

	ngOnInit() {}

	onClick() {
		location.href = `tel:${this.control.attributes.phone}`;
	}
}
